//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Carousel from "@/components/carousel/carousel";
import Card from "@/components/Card/card";
import HandleCard from "@/components/handleCard/handleCard";
import Steps from "@/components/steps/steps";
export default {
  data: function data() {
    return {
      deNum: 6,
      //默认划过
      cardList: [{
        img: require('@/assets/Home/01_off.png'),
        img2: require('@/assets/Home/01_on.png'),
        title1: "投标保函",
        title2: '(招投标阶段)',
        text: "投标保函是指在招标投标中招标人为保证投标人不得撤销投标文件、中标后不得无正当理由不与招标人订立合同等、要求投标人在提交投标文件时一并提交的一般有银行出具的书面担保。"
      }, {
        img: require('@/assets/Home/02_off.png'),
        img2: require('@/assets/Home/02_on.png'),
        title1: "履约保函",
        title2: '(合同签订阶段)',
        text: "应劳动方和承包方(申请人)的请求，银行金融机构向工程的业主方(受益人)做出的一种履约保证承诺。"
      }, {
        img: require('@/assets/Home/03_off.png'),
        img2: require('@/assets/Home/03_on.png'),
        title1: "预付款保函",
        title2: '(预付款保函)',
        text: "投标人在中标后签订的合同中规定,承包人委托银行向业主出具的由业主按合同规定向承包人支付一笔工程预付款,及时用于实施项目的保证函件。担保银行应为业主所接受。如承包人不履约，业主可凭保函向担保银行索赔。"
      }, {
        img: require('@/assets/Home/04_off.png'),
        img2: require('@/assets/Home/04_on.png'),
        title1: "农民工工资支付担保",
        title2: '(竣工阶段)',
        text: "指担保人对业主或承包商支付民工工资义务的担保，一旦业主或承包商违约，不能按时、足额支付民工工资，担保人将代为支付(之后担保人再向业主或承包商追债)。以保障(农)民工的合法权益。"
      }, {
        img: require('@/assets/Home/05_off.png'),
        img2: require('@/assets/Home/05_on.png'),
        title1: "质量/维修保函",
        title2: '(保修阶段)',
        text: "也称为'维修保函',是指应供货方或承建人申请，向买方或业主保证,如货物或工程的质量不符合合同约定而卖方或承建人又不能依约更换或修理时。按买方或业主的索赔予以赔偿的书面文件。"
      }],
      handleList: [{
        img: require('@/assets/outLine.png'),
        title: '线下门店',
        text: "各地分店机构"
      }, {
        img: require("@/assets/pc.png"),
        title: "电脑客户端",
        text: '网页宣传,合作操作'
      }, {
        img: require("@/assets/app.png"),
        title: "手机App",
        text: '随心所欲,随地办理'
      }],
      stepslist: [{
        text: '1提交，审核',
        icon: 'el-icon-s-open'
      }, {
        text: '2付款，材料提交银行',
        icon: 'el-icon-s-open'
      }, {
        text: "3银行审核",
        icon: 'el-icon-s-open'
      }, {
        text: '4签字盖章',
        icon: 'el-icon-s-open'
      }, {
        text: '5出函成功',
        icon: 'el-icon-s-open'
      }]
    };
  },
  components: {
    Carousel: Carousel,
    Card: Card,
    HandleCard: HandleCard,
    Steps: Steps
  },
  methods: {
    //划入
    hr: function hr(index) {
      this.deNum = index;
    },
    //划出
    hc: function hc(index) {
      this.deNum = 6;
    }
  }
};